import * as React from "react"
import * as ReactDom from "react-dom"

import View from "../views/otherPage"

//
  
ReactDom.render(<View /> , document.getElementById('app'))

export const page = async () => {
	require('../js/otherPage.js').init()
}